import { timestamp } from '@qapline/helpers';

// `value` is a unix timestamp in SECONDS.
export const formatUnixDate = (value: string | number, options: { includeTime?: boolean } = {}) => {
    const { includeTime } = options;
    return value ? timestamp(value)?.format(`DD.MM.YYYY${includeTime ? ' HH:mm' : ''}`) : undefined;
};

export const formatPrice = (value: number | undefined, digits: number | undefined = 2) =>
    value?.toLocaleString('cs-CZ', { minimumFractionDigits: digits, maximumFractionDigits: digits });
